export default __webpack_public_path__ + "static/media/36I-114283_-20940_0.68b7342c.jpg";